"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Spinner_1 = require("../components/Spinner");
var SignupContext_1 = require("../SignupContext");
var hooks_1 = require("preact/hooks");
var SignUpStep1 = function (_a) {
    var handleAnimationEvent = _a.handleAnimationEvent, discountPercent = _a.discountPercent;
    var setModalOpen = (0, hooks_1.useContext)(SignupContext_1.SignupContext).setModalOpen;
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("b", { class: "signup-discount__text signup-discount__text--type" }, "SPIN TO WIN"),
        (0, preact_1.h)("p", { class: "signup-discount__text signup-discount__text--unlock" },
            "Unlock up to ",
            discountPercent,
            " off"),
        (0, preact_1.h)("button", { class: "signup-modal__cancel signup-modal__cancel--first", onClick: function () {
                setModalOpen(false);
            } }, "No Thanks"),
        (0, preact_1.h)(Spinner_1.default, { onAnimationEnd: handleAnimationEvent })));
};
exports.default = SignUpStep1;
